

import { useQuery } from 'react-query';
import { SrxApi } from '../../api/SrxApi';
import { toast } from 'react-toastify';

const useGetDischargeMedList = (facId, patId, dispenseDt) => {
    const {
        data,
        isLoading,
        refetch,
    } = useQuery(
        ['dischargeMedList', facId, patId, dispenseDt],
        async () => {
            const response = await SrxApi.get(
                `/dischargesummary/medlist?FacId=${facId}&patid=${patId}&dispenseDt=${dispenseDt}`
            );

            const list = response?.data?.data;
            return {
                list: Array.isArray(list) ? list : [],
                message: response?.data?.message || 'No medications found for this patient.',
            };
        },
        {
            enabled: false,

            onError: (error) => {
                toast.error(
                    error?.response?.data?.message ||
                    'Failed to fetch medication list'
                );
            },
        }
    );

    return {
        medicationList: data?.list || [],
        isGetDischargeMedListLoading: isLoading,
        getDischargeMedList: refetch,
    };
};

export default useGetDischargeMedList;
